import { Component, input, output, signal, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ExecutionFormComponent } from '../../../../utils/execution-form/execution-form.component';
import { Tool } from '../../../../utils/models/tool.models';
import { InputMapping } from '../../../../utils/models/toolchain.models';

@Component({
  selector: 'app-input-parameter-node',
  templateUrl: './input-parameter-node.component.html',
  styleUrls: ['./input-parameter-node.component.scss'],
  imports: [ExecutionFormComponent],
})
export class InputParameterNodeComponent {
  /** Inputs. */
  readonly tool = input.required<Tool>();
  readonly outputsToMap = input<InputMapping[]>([]);
  readonly startJob = input.required<(form: FormGroup) => Promise<void>>();

  /** Outputs. */
  readonly submittingChange = output<boolean>();

  /** State. */
  readonly executionForm = viewChild.required(ExecutionFormComponent);
  readonly submitting = signal(false);

  /** Starts a job with the submitted form values. */
  async onSubmit(form: FormGroup): Promise<void> {
    if (this.submitting()) return;

    this.submitting.set(true);
    this.submittingChange.emit(true);
    try {
      await this.startJob()(form);
      this.executionForm().resetForm();
    } finally {
      this.submitting.set(false);
      this.submittingChange.emit(false);
    }
  }
}
